module.exports = __webpack_public_path__ + "img/checklist (1).f18b092b.png";